// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2dgIx","title":"InfoRow_title__3uA_d"};